// Shared wording and colors for the Commitment Scanner screens.

export const STATUS_BADGE = {
  Committed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  "Likely Uncommitted": "bg-slate-500/15 text-slate-300 border-slate-500/40",
  "Needs Review": "bg-amber-500/15 text-amber-300 border-amber-500/40",
};

export const MATCH_LABEL = {
  profile: "From profile",
  x_link: "Same X account",
  name_school: "Name + school",
  name_only: "Name only — check",
  manual: "Picked by admin",
  ambiguous: "Several possible",
  none: "No profile found",
};

// Matches safe to approve in bulk (mirrors the back end)
export const TRUSTED_MATCHES = ["profile", "x_link", "name_school", "manual"];

export const CHANGE_LABEL = {
  new: "New commitment",
  school: "Different school",
  decommit: "Possible de-commit",
  same: "No change",
  review: "Unclear",
};

export const playerName = (p) => (p ? `${p.firstName || ""} ${p.lastName || ""}`.trim() : "");

export const profileNow = (p) => {
  if (!p) return "—";
  if (p.commitmentStatus === "committed") return p.committedTo ? `Committed: ${p.committedTo}` : "Committed";
  return "Uncommitted";
};

export const errorText = (err) => err?.response?.data?.message || err?.message || "Something went wrong";
